import { createFileRoute } from '@tanstack/react-router';

import { ClientLibraryBookmarksScreen } from '@/features/engagement/components/ClientLibraryBookmarksScreen';

export const Route = createFileRoute('/client/library/bookmarks')({
  component: ClientLibraryBookmarksRoute,
});

function ClientLibraryBookmarksRoute() {
  return <ClientLibraryBookmarksScreen />;
}
